export default {
  general: {
    name: "Flow Simulation Game",
    yes: "Oui",
    no: "Non",
    week: "Semaine",
    add: "Ajouter",
    update: "Modifier",
    close: "Fermer",
    cancel: "Annuler",
    search: "Recherche",
    actions: "Actions",
    language: "Langue",
    smallWeek: "S"
  },
  menu : {
    home : 'Accueil',
    games : 'Parties',
    gameVersions : "Version de jeu",
    demandProfiles : "profil de demande",
    instructions : "Instructions",
    users: "Utilisateurs",
    params : "Jetons",
    logout : "Déconnexion",
    profile: "Mon compte"
  },
  fields: {
    required: "Requis"
  },
  tokens: {
    token: "Token | Tokens",
    balance: "Votre Solde est actuellement de {nbr} jeton | Votre Solde est actuellement de {nbr} jetons",
    title: "Tokens",
    date: "Date",
    orders: "Token order history",
    number: "Number of tokens",
    cost: "Cost",
    bill: "Bill",
    status: "Status"
  },
  users: {
    firstname: "Prénom",
    lastname: "Nom",
    login: "Login",
    role: "Rôle",
    password: "Mot de passe",
    lang: "Langue",
    passwordRule: "8 caractères minimum",
    passwordConfirmation: "Le mot de passe doit être identique",
    confirmation: "Confirmation",
    listTitle: "Utilisateurs",
    addTitle: "Ajout d'un utilisateur",
    updateTitle: "Modification d'un utilisateur",
    deleteConfirmation: "Etes vous sur de vouloir supprimer {count} utilisateur ? | Etes vous sur de vouloir supprimer {count} utilisateurs ?"
  },
  roles: {
    trainner: "Formateur",
    admin: "Administrateur",
    superAdmin: "Super Administrateur"
  },
  demandProfiles: {
    name: "Nom",
    type: "Type de profil",
    min: "Min",
    max: "Max",
    constant: "Valeur constante",
    variability: "Variabilité",
    confirmation: "Confirmation",
    customDemandsTitle: "profil de demande personnalisé",
    importDemandsButton: "Importer des demandes",
    importDemandsTemplateButton: "Télécharger le template Excel",
    weekNumber: "Semaine N°",
    demands: "Demandes",
    listTitle: "Profils de demandes",
    addTitle: "Ajout d'un profil de demande",
    updateTitle: "Modification d'un profil de demande",
    deleteConfirmation: "Etes vous sur de vouloir supprimer {count} profil de demande ? | Etes vous sur de vouloir supprimer {count} profils de demande ?",
    typeList: {
      custom: "Customisé",
      randomBetweenTwoValue: "Aléatoire entre deux bornes",
      constant: "Valeur constante"
    },
    variabilityHint: "En % (ex: 20% demandes de 10 valeur entre 8 et 12)"
  },
  instructions: {
    name: "Nom",
    addInstruction: "Ajout d'une instruction",
    listTitle: "Liste d'instructions",
    addTitle: "Ajout d'une série d'instruction",
    updateTitle: "Modification d'une liste d'instructions",
    deleteConfirmation: "Etes vous sur de vouloir supprimer {count} liste d'instructions ? | Etes vous sur de vouloir supprimer {count} listes d'instructions ?"
  },
  gameVersions: {
    type: "Type",
    dd: "DD",
    standard: "Standard",
    updateLogo: "Modifier le logo",
    menu: "Menu",
    params: "Paramètres",
    style: "Styles",
    name: "Nom",
    colors: {
      primary: "Couleur primaire",
      secondary: "Couleur secondaire"
    },
    maxOrder: "Commande fournisseur maximum",
    skipInstructions: "Passer les instructions",
    timerActivated: "Activer un timer quotidien",
    timerCount: "Durée du timer",
    timerCountHint: "Secondes par tour",
    storageCost: "Coût de stockage",
    delayCost: "Coût des ruptures",
    weekNbrAutoCmj: "Nbr de semaine pour le calcul de la CMJ",
    changeBufferEveryNbrWeek: "Le buffer peut être modifié toutes les X semaines",
    versionToDuplicate: "Version du jeu à dupliquer",
    listTitle: "Versions du jeu",
    addTitle: "Ajout d'une version du jeu",
    addNew: "Nouvelle version",
    addFromVersion: "A partir d'une version existante",
    updateTitle: "Modification d'une version du jeu",
    deleteConfirmation: "Etes vous sur de vouloir supprimer {count} version du jeu ? | Etes vous sur de vouloir supprimer {count} versions du jeu ?",
    flowEquationDisplayModes: {
      title: "Mode d'affichage de l'équation de flux",
      notDisplay: "Ne pas afficher l'équation de flux",
      alreadyCalculated: "Afficher l'équation de flux pré-remplie",
      show: "Faire remplir l'équation de flux par le participant"
    },
    ddOrderPreFilled: "Pré-remplir la quantité a commander en mode DD"
  },
  games: {
    test: "Mode de test",
    favorites: "Favori",
    name: "Nom",
    code: "Code",
    version: "Version",
    createdBy: "Crée par",
    createdAt: "Crée le",
    status: "Status",
    listTitle: "Parties de jeu",
    addTitle: "Créer une partie",
    deleteConfirmation: "Etes vous sur de vouloir supprimer {count} partie de jeu ? | Etes vous sur de vouloir supprimer {count} parties de jeu ?",
    statusList: {
      created: "Créé",
      open: "Ouverte",
      inProgress: "Encours",
      finished: "Finis"
    },
    pause: "Le jeu a été mis en pause",
    play: "Le jeu est relancé",
    stop: "Vous avez mis fin au jeu",
    start: "Vous avez relancé le jeu",
    debriefOn: "Vous avez donné accès au debrief",
    debriefOff: "Vous avez annulé l'accès au debrief"
  },
  inGame: {
    delete: "Supprimer la partie et récupérer ses jetons",
    deleteConfirmation: "Êtes vous sur de vouloir supprimer définitivement la partie ?",
    setPause: "Mettre le jeu en pause",
    setPlay: "Annuler la pause du jeu",
    endGame: "Mettre fin à la partie",
    reopenGame: "Relance la partie",
    debriefOn: "Donner accès au debrief",
    debriefOff: "Masquer le debrief",
    companies: {
      playerName: "Joueur",
      companies: "Maillons",
      step: "Etape",
      assigned: "Connecté",
      ready: "Prêt",
      code: "Code",
      steps: {
        clientOrder: "Commandes client",
        clientShipment: "Expéditions client",
        supplierShimpentWaiting: "En attente des livraisons",
        board: "Tableau de bord",
        supplierShipments: "Livraisons fournisseur",
        supplierOrders: "Commandes fournisseur",
        productionBatch: "Lancement en production",
        productionShipments: "Reception de la production",
        startNewWeek: "Démmarer une nouvelle semaine",
        inProgressProduction: "Production en cours"
      }
    },
    resume: {
      resume: "Synthèse",
      averageOrderQuantity: "Moyenne de la demande vers le fournisseur",
      averageRequestQuantity: "Moyenne de la demande du client",
      range: "Etendue de la demande",
      otd: "Ponctualité",
      delaysDepth: "Profondeur des retards",
      averageStock: "Stock moyen",
      stockCost: "Coût de stockage",
      delayCost: "Coût des ruptures",
      cost: "Coût total",
    },
    red: "Zone rouge",
    yellow: "Zone jaune",
    green: "Zone verte",
    flowEquation: "Equation de flux",
    stock: "Stock",
    buffers: "Buffers",
    orders: "Commandes",
    costs: "Coûts",
    stockRemains: "Stock et ruptures",
    shortage: "Rupture",
    supplychainGraph: "Supply Chain",
    repport: "Rapport PDF"
  },
  companiesSettings: {
    supplyPicture: "Image de la supplychain",
    logo: "Logo",
    name: "Nom",
    level: "Rang",
    suppliers: "Fournisseur(s)",
    clients: "Client(s)",
    leadTime: "Lead Time d'expédition",
    productionLeadTime: "Lead Time de production",
    initialStock: "Stock initial",
    firstOrder: "Commande initiale",
    firstProduction: "Production initiale",
    ddOn: "Mode DD activé",
    simulatedCompany: "Client simulé par l'ordinateur",
    productionCompany: "Usine de production",
    assemblyMode: "Mode assemblage",
    demandProfile: "profil de demande",
    confirmation: "Confirmation",
    listTitle: "Maillons",
    addTitle: "Ajout d'un maillon",
    updateTitle: "Modification d'un maillon",
    deleteConfirmation: "Etes vous sur de vouloir supprimer {count} maillon ? | Etes vous sur de vouloir supprimer {count} maillons ?",
    updateLogo: "Modifier le logo",
    updateSupplyPicture: "Modifier l'image de la supply"
  },
  notifications: {
    users: {
      welcome : "Bienvenue ",
      sessionExpired : "Votre session a expiré, merci de vous reconnecter",
      getOneError: "Erreur lors du chargement de l'utilisateur : ",
      getAllError: "Erreur lors du chargement des utilisateurs : ",
      add: "L'utilisateur a bien été ajouté",
      addError: "Erreur lors de la création de l'utilisateur : ",
      update: "L'utilisateur a bien été modifié",
      updateError: "Erreur lors de la modification de l'utilisateur : ",
      delete: "La suppression a bien été réalisé",
      deleteError: "Erreur lors de la suppression des utilisateurs : "
    },
    demandProfiles: {
      getOneError: "Erreur lors du chargement du profil de demande : ",
      getAllError: "Erreur lors du chargement des profils de demandes : ",
      add: "Le profil de demande a bien été ajouté",
      addError: "Erreur lors de la création du profil de demande : ",
      update: "Le profil de demande a bien été modifié",
      updateError: "Erreur lors de la modification du profil de demande : ",
      delete: "La suppression a bien été réalisé",
      deleteError: "Erreur lors de la suppression des profils de demandes : "
    },
    gameVersions: {
      getOneError: "Erreur lors du chargement de la version du jeu : ",
      getAllError: "Erreur lors du chargement des versions du jeu : ",
      add: "La version du jeu a bien été ajouté",
      addError: "Erreur lors de la création de la version du jeu : ",
      update: "La version du jeu a bien été modifié",
      updateError: "Erreur lors de la modification de la version du jeu : ",
      delete: "La suppression a bien été réalisé",
      deleteError: "Erreur lors de la suppression des versions du jeu : "
    },
    companiesSettings: {
      getOneError: "Erreur lors du chargement du maillon : ",
      getAllError: "Erreur lors du chargement des maillons : ",
      add: "Le maillon a bien été ajouté",
      addError: "Erreur lors de la création du maillon : ",
      update: "Le maillon a bien été modifié",
      updateError: "Erreur lors de la modification du maillon : ",
      delete: "La suppression a bien été réalisé",
      deleteError: "Erreur lors de la suppression des maillons : "
    },
    games: {
      getOneError: "Erreur lors du chargement de la partie de jeu : ",
      getAllError: "Erreur lors du chargement des parties de jeu : ",
      add: "La partie de jeu a bien été ajoutée",
      addError: "Erreur lors de la création de la partie de jeu : ",
      update: "La partie de jeu a bien été modifiée",
      updateDemands: "Le profil de demande a bien été modifié",
      updateDemandsError: "Erreur lors de la modification du profil de demande : ",
      updateError: "Erreur lors de la modification de la partie de jeu : ",
      delete: "La suppression a bien été réalisé",
      deleteError: "Erreur lors de la suppression des parties de jeu : "
    }
  },
  socketMessages: {
    playerReady : "Le maillon suivant est prêt : ",
    stepChange : "Le maillon suivant change d'étape : ",
    connexion : "Connexion du maillon : ",
    clientsShipments : "Le maillon suivant livre ses clients : ",
    suppliersOrders : "Le maillon suivant a passé commande : ",
    productionBatch: "Le maillon suivant a lancé en production : ",
    customerUpdate: "Mise à jour des données du maillon : "
  }
}